import getIsArvatoLoading from '../../../selectors/PaymentOptionSelectors/Arvato/getIsArvatoLoading';
import * as actionTypes from '../../action-types';
import * as CheckoutAPIActions from '../../APIActions/CheckoutAPIActions';

const updateArvatoOptions = arvatoSession => ({
  type: actionTypes.UPDATE_ARVATO_OPTIONS,
  arvatoSession,
});

const updateArvatoLoading = loadingOptions => ({
  type: actionTypes.UPDATE_ARVATO_LOADING,
  loadingOptions,
});

export default () => (dispatch, getState) => {
  dispatch(updateArvatoLoading(getIsArvatoLoading(getState())));
  dispatch(CheckoutAPIActions.getAvailableArvatoOptions())
    .then((arvatoSessionResponse) => {
      let responseStatus = arvatoSessionResponse?.msg?.responseStatus;
      if (arvatoSessionResponse?.msg?.paymentMethodCategories.length === 0) {
        responseStatus = 'DEFAULT';
      }
  
      dispatch(updateArvatoOptions({
        paymentMethodCategories: arvatoSessionResponse?.msg?.paymentMethodCategories,
        responseStatus,
        clientId: arvatoSessionResponse?.msg?.clientId,
      }));
    })
    .catch(() => {
      dispatch(updateArvatoOptions({
        paymentMethodCategories: null,
        responseStatus: 'DEFAULT',
      }));
    })
    .finally(() => {
      dispatch(updateArvatoLoading(getIsArvatoLoading(getState())));
    });
};
